var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13708_1815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9995 39.9989C31.0449 39.9989 39.9989 31.0449 39.9989 19.9995C39.9989 8.95407 31.0449 0 19.9995 0C8.95407 0 0 8.95407 0 19.9995C0 31.0449 8.95407 39.9989 19.9995 39.9989Z",
    fill: "#EF8035"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3408 23.1875C15.1018 23.1875 16.5293 21.76 16.5293 19.999C16.5293 18.2381 15.1018 16.8105 13.3408 16.8105C11.5799 16.8105 10.1523 18.2381 10.1523 19.999C10.1523 21.76 11.5799 23.1875 13.3408 23.1875Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6592 23.1875C28.4201 23.1875 29.8477 21.76 29.8477 19.999C29.8477 18.2381 28.4201 16.8105 26.6592 16.8105C24.8982 16.8105 23.4707 18.2381 23.4707 19.999C23.4707 21.76 24.8982 23.1875 26.6592 23.1875Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4848 30.4668H14.5146C14.0175 30.4668 13.6133 30.0636 13.6133 29.5654C13.6133 29.0672 14.0165 28.6641 14.5146 28.6641H25.4848C25.9819 28.6641 26.3862 29.0672 26.3862 29.5654C26.3862 30.0636 25.983 30.4668 25.4848 30.4668Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13708_1815"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNormal);
export default __webpack_public_path__ + "static/media/normal.5ac3faca2a7ecbb4979cf63ae3853536.svg";
export { ForwardRef as ReactComponent };